import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

import type {EstimatedInvoice} from './next-estimated-invoice';
import {PreviousInvoices} from './previous-invoices';

type Props = {
    nextEstimatedInvoice: EstimatedInvoice | null | undefined;
    lastThreeInvoices: EstimatedInvoice[] | null | undefined;
};

export function InvoiceDetails(props: Props) {
    return (
        <StackLegacy spacing={16}>
            <StackLegacy spacing={8}>
                {props.nextEstimatedInvoice ? (
                    <>
                        <Body as='div' isBold={true}>
                            <FormattedTimestamp
                                format={FormattedTimestamp.formats.longMonthDayWithYear}
                                datetime={props.nextEstimatedInvoice.date}
                            />
                        </Body>
                        <Body as='div' isBold={true} size='large'>
                            {props.nextEstimatedInvoice.amount}
                        </Body>
                    </>
                ) : (
                    <Body isItalic={true}>No estimated invoice</Body>
                )}
            </StackLegacy>
            {props.lastThreeInvoices && props.lastThreeInvoices.length > 0 && (
                <PreviousInvoices lastThreeInvoices={props.lastThreeInvoices} />
            )}
        </StackLegacy>
    );
}
